import {Component, inject, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from "@angular/common";
import {DividerComponent} from "../divider/divider.component";
import PhonePipe from "../../pipes/phone.pipe";
import {DropdownComponent, DropDownItem} from "../dropdown/dropdown.component";
import {PhoneProduct} from "../../model/product.model";
import {Call} from "../../model/call.model";
import CallStore from "../../services/Stores/call.store";
import {CallDurationPipe} from "../../pipes/call-duration.pipe";
import Relation from "../../model/relation.model";
import {AuthService} from "../../services/auth.service";
import {CurrencyComponent} from "../currency/currency.component";

@Component({
    selector: 'app-phone-details-display',
    imports: [
    DividerComponent,
    PhonePipe,
    DropdownComponent,
    DatePipe,
    CallDurationPipe,
    CurrencyComponent
],
    templateUrl: './phone-details-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './phone-details-display.component.scss'
})
export class PhoneDetailsDisplayComponent implements OnInit {
  private readonly callStore: CallStore = inject(CallStore);
  private readonly authService: AuthService = inject(AuthService);

  @Input() product!: PhoneProduct;

  public selected: {
    year: number;
    month: number;
  } = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  }
  public calls: Call[] = [];
  public isBusiness: boolean | null = null;

  public ngOnInit(): void {
    this.authService.getActiveRelation().subscribe((relation: Relation | null) => {
      if (relation === null) {
        return;
      }

      this.isBusiness = relation.is_business;
    });
    this.loadCalls();
  }

  private loadCalls(): void {
    if (this.product && this.product.product_type === 'voip_accounts') {
      this.calls = [];
      this.callStore.reset().forParent('products', this.product).all({
        year: this.selected.year,
        month: this.selected.month,
      }).subscribe((calls: Call[]) => {
        this.calls = calls;
      });
    }
  }

  public dropDownOptions(): DropDownItem[] {
    const currentYear: number = new Date().getFullYear();
    const firstYear: number = currentYear - 1;

    const years: number[] = [];
    for (let year: number = firstYear; year <= currentYear; year++) {
      years.push(year);
    }

    const months: string[] = [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December',
    ];

    const currentMonth: number = new Date().getMonth();

    //loop through the years and months, the label is the year and the value is the month
    const options: DropDownItem[] = [];
    for (const year of years) {
      for (let month: number = 0; month < 12; month++) {
        //if the year is the current year, only show the months that have passed
        if (year === currentYear && month > currentMonth) {
          continue;
        }
        options.push({
          label: `${months[month]} ${year}`,
          value: {
            year,
            month: month + 1,
          }
        });
      }
    }

    //reverse the array so the newest date is on top
    return options.reverse();
  }

  public selectionChanged($event: unknown): void {
    this.selected = $event as { year: number, month: number };
    this.loadCalls()
  }
}
